<main id="site-main">
    <div class="inner-content">
        <section id="hero">
            <div class="content pb-md-5">
                <h1>سامانه پایش و مدیریت هوشمند تانکرهای آبرسان</h1>
                <h2>شرکت آب و فاضلاب استان اصفهان</h2>
                <div class="w-100 my-3">
                    <button class="btn btn-primary btn-lg" routerLink="/login/profile">
                        <i class="fa fa-sign-in fa-lg me-2"></i>
                        ورود | ثبت‌نام
                    </button>
                </div>

                <h3> در صورت بروز مشکل در ثبت‌نام و یا پرداخت با شماره زیر تماس حاصل فرمایید</h3>
                <h4 class="">
                    <a href="tel:09384754683" class="">
                        {{'09384754683' | faNum}}
                    </a>
                </h4>
            </div>
        </section>
    </div>
</main>
<app-footer></app-footer>